import React, { useContext, useMemo } from "react";
import styled, { useTheme } from "styled-components";
import { Flex } from "reflexbox";
import LineTable from "./LineTable";
import { Heading, Body } from "../../UI/Text";
import formatter from "../../../modules/formatter";
import moment from "moment";
import _ from "lodash";
import ConfiguratorContext from "../../../context/configurator/ConfiguratorContext";
import TermsAndConditions from "./TermsAndConditions";
// import { formatPhoneNumber } from "../../modules/utilities";


export const TermsStyled = styled.div`
  display: none;  
  @media print {
    page-break-before: always;
    display: block;
  }
`; 

export const CustomerInfo = () => {
  const { quote } = useContext(ConfiguratorContext);
  const { shippingAddress, billingAddress } = quote || {};
  const addresses = [billingAddress, shippingAddress];
  const { sameAsShipping } = billingAddress || {};
  const theme = useTheme();  
};

export const CommunicationList = ({ communications }) => {
  if (!communications || !_.isArray(communications)) return null;

  return (
    <Flex width={1} flexDirection="column">
      {communications.map((item, i) => {
        const { id, comment, date, username } = item || {};
        return (
          <Flex
            key={id}
            width={1}
            justifyContent="space-between"
            alignItems="center"
          >
            <Body ellipsis>
              {`${moment(date).format("MM/DD/YYYY")}`}
              {" – "}
              {comment}
              {i === 0 ? " by " : " – "}
              {username}
            </Body>
          </Flex>
        );
      })}
    </Flex>
  );
};

const PrintQuote = React.forwardRef((props, ref) => {
  const theme = useTheme();
  const { emailLogo } = theme || {};
  const {
    lines: rows,
    lineCount: count,
    //communications,
    lineLoading,
  } = props || {};  

  const { quote } = useContext(ConfiguratorContext);

  const { id: quoteId, type, billingAddress } = quote || {};

  const price = useMemo(() => {
    let total = 0;
    if (quote?.lines && quote?.lines?.length > 0) {
      for (let line of quote?.lines) {
        const { quantity = 1, price } = line;
        total += quantity * price;
      }

      return `$${formatter.currency(total)}`;
    }

    return `$${formatter.currency(0)}`;
  }, [quote]);
  const { sameAsShipping } = billingAddress || {};

  const jobName = useMemo(() => quote?.jobName || "", [quote]);
  const specifier = useMemo(() => quote?.specifier || "", [quote]);
  const specifierLocation = useMemo(() => quote?.specifierLocation || "", [quote]);

  const createdAt = new Date(quote?.createdAt);

  // Add 60 days
  const newDate = new Date(createdAt);
  newDate.setDate(newDate.getDate() + 60);

  // Format the new date (optional)
  const expirationDate = newDate.toISOString().split('T')[0];

  return (
    <>
      <style type="text/css" media="print">
        {`
          .no-print { 
            display: none; 
          }
          
          @media print {
            .print-col {
              margin-bottom: -3rem;
              width: ${sameAsShipping ? "50%" : "50%"} !important;
            }
            #price {
              opacity: 1;
            }
            .printquote {
              display: block;
            }
            html,
            body {
              padding: 1rem;
              height: 99vh;
            }
          }
        `}
      </style>
      <style type="text/css">
        {`
          .no-summary {
            display: none;
          }
          .print-col {
            margin-bottom: 1rem;
          }
          @media print {
            .printquote {
              display: block;
            }
            #price {
              opacity: 1;
            }
            .no-summary {
              display: block;
            }
            html,
            body {
              height: 99vh;
            }
          }

        `}
      </style>

      {/* remove total cost and quote header on summary page */}
      <div
        className="printquote no-summary"
        ref={ref}
        style={{ width: "100%", height: "auto" }}
      >
        <div className="container" style={{display: "flex"}}>
        <Flex width={1} flexDirection="column" alignItems="flex-start">  
        <Body bold left>                                                 
            <img
              width="150px"              
              src={emailLogo}
              alt="SwiftSell"
            />     
          </Body>                    
          <Body bold left>
            Agency Name:{" "}
            <span style={{ color: theme.secondary }}>{quote?.customerName}</span>
          </Body>               
                                     
            <Body bold left>
              Contact Name:{" "}
              <span style={{ color: theme.secondary }}>{quote?.createdByFirstName}{" "}{quote?.createdByLastName}</span>
            </Body> 

             <Body bold left>
              Expiration Date:{" "}
                <span style={{ color: theme.secondary }}>{expirationDate}</span>
          </Body>             
          </Flex> 
          <Flex width={1} flexDirection="column" alignItems="flex-start">            
            <Heading right >
                {`${["Quote", "Order", "Quote Request"][type - 1]} #${quoteId}`}
            </Heading>
           
            <Body bold right>Total: {" "}
              <span style={{ color: theme.secondary }}>{price}</span></Body>
            <Body bold right>
              Job Name:{" "}
              <span style={{ color: theme.secondary }}>{jobName}</span>
            </Body>
            <Body bold right>
              Specifier:{" "}
              <span style={{ color: theme.secondary }}>{specifier}</span>
            </Body>
            <Body bold right>
              Specifier Location:{" "}
              <span style={{ color: theme.secondary }}>{specifierLocation}</span>
            </Body>
          </Flex>

        </div>
        

          {/* <CustomerInfo /> */}
          
          <br />
          <>
           NOTE: All quotes through Selux Online Sales are full commission, no discount. For other pricing options, please contact your Selux Inside Sales team or Regional Sales Manager.
          </>
      
          <LineTable
            lineLoading={lineLoading}
            quote={quote}
            lines={rows}
            open
            lineCount={count}
            quoteId={quoteId}
            printQuote
          />
             
          <div>
            <div>SMALL ORDER SURCHARGE NOTICE:</div>
            <br />
            <div>In order to help maintain our commitment to quality and service, a 20% surcharge will be added to orders below $5,000.00USD / $6,2500.00CAD. The total charge for these orders including the surcharge will not exceed $5,000,00USD / $6,250.00CAD.</div>
            <br />
            <div>Please contact us with any questions</div>
          </div>
          <TermsStyled>
            <TermsAndConditions />

            
          </TermsStyled>
            
          {/* <CommunicationList communications={communications} /> */}
     
      </div>
    </>
  );
});

export default PrintQuote;
